import pcPage from "./components/pcPage.vue";
import mobilePage from "./components/mobilePage.vue";
export default {
  name: "App",
  components: {
    pcPage,
    mobilePage
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      component: ""
    };
  },
  watch: {
    screenWidth: {
      handler(val) {
        this.component = val < 750 ? "mobilePage" : "pcPage";
      },
      immediate: true
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  }
};